export default __webpack_public_path__ + "static/glance-global-nd-2e09612e96a9794270c96d001a8e67b3.jpg";